import { render, staticRenderFns } from "./editPlate.vue?vue&type=template&id=e3c18962&scoped=true&"
import script from "./editPlate.vue?vue&type=script&lang=js&"
export * from "./editPlate.vue?vue&type=script&lang=js&"
import style0 from "./editPlate.vue?vue&type=style&index=0&id=e3c18962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c18962",
  null
  
)

export default component.exports